<template>
  <div>
    <data-select
      :size="size"
      :title="title"
      :defaultParams="defaultParams"
      :placeholder="placeholder"
      :fieldList="fieldList"
      :paramList="paramList"
      :width="1000"
      :showMenu="showMenu"
      :menuWidth="200"
      listApi="biz.warehouse.goods.info.list"
      valuePropName="guid"
    >
      <template v-if="showMenu" slot="menu" slot-scope="scope">
        <warehouse-goods-classify-list
          @change="handleClassifyChange"
          :value="classifyGuid"
          :storeGuid="storeGuid"
          :offsetSize="120"
        />
      </template>
      <template slot="row-info" slot-scope="scope">
        <goods-sku-info :skuInfo="scope.row">
          <template slot="info-append" slot-scope="scope1">
            <slot name="info-append" :info="scope.row" />
          </template>
        </goods-sku-info>
      </template>
    </data-select>
  </div>
</template>

<style lang="less" scoped>
.select-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  font-size: 14px;
}
.select-footer {
  margin-top: 10px;
  text-align: right;
}
</style>

<script>
import dataSelect from "../dataSelect.vue";
import goodsSkuInfo from "./goodsSkuInfo.vue";
import warehouseGoodsClassifyList from "./warehouseGoodsClassifyList.vue";

export default {
  components: {
    dataSelect,
    goodsSkuInfo,
    warehouseGoodsClassifyList,
  },
  props: {
    size: {
      type: String,
    },
    title: {
      type: String,
      default: "请选择",
    },
    placeholder: {
      type: String,
      default: "选择库存商品",
    },
    showMenu: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
    storeGuid: {
      type: String,
    },
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    defaultParams() {
      return Object.assign(
        {
          optStatus: 1,
          storeGuid: this.storeGuid,
          classifyGuid: this.classifyGuid,
        },
        this.params || {},
        this.queryModel || {}
      );
    },
  },
  data() {
    return {
      queryModel: {},
      classifyGuid: "",
      fieldList: [
        {
          label: "商品信息",
          minWidth: "320",
          slot: "info",
        },
      ],
      paramList: [
        {
          label: "查询关键词",
          field: ["queryValue"],
          styleValue: "width: 300px",
        },
      ],
    };
  },
  methods: {
    handleClassifyChange(guid) {
      this.classifyGuid = guid;
    },
  },
};
</script>
